import React, { useState } from 'react';
import '../sunpharma(1)/css/lea_virtual.css';
import { useNavigate } from 'react-router-dom';
import Virtual_video from '../video/virtual.mp4';
import Swal from 'sweetalert2';
import HomeBtn from '../components/HomeBtn';
import Footer from '../components/footer';
import Com_Logo from '../components/company_icon';

const VideoPage = () => {
  const [videoPlayed, setVideoPlayed] = useState(false);
  const navigate = useNavigate();

  const handleVideoPlay = () => {
    setVideoPlayed(true);
  };

  const handleNext = () => {
    if (videoPlayed) {
        Swal.fire({
            title: 'Are you ready for quiz ?',
            text: 'Do you want to proceed?',
            
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
          }).then((result) => {
            if (result.isConfirmed) {
              //  Yes clicked
              navigate('/mcq');
            } else {
              //  No clicked
              navigate('/lea_video');
            }
          });
  };
}
  

  return (
    <>
      <Com_Logo />

      <div className="lea-container">
        <div className="lea-card">
          <div className="lea-card-header">E - Virtual Meeting</div>

          <div className="lea-card-body">
            <div className="video-section">
              <h2 className="section-title"></h2>
              <div className="video-wrapper">
                <video
                  controls
                  className="responsive-video"
                  onPlay={handleVideoPlay}
                >
                  <source src={Virtual_video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>

          {videoPlayed && (
            <div className="lea-card-footer">
              <button className="lea-btn secondary" onClick={() => navigate('/lea_event')}>
                Prev
              </button>
              <HomeBtn/>
              <button className="lea-btn primaryy" onClick={handleNext}>
                Next
              </button>
            </div>
          )}
        </div>
      </div>

   
    <Footer/>
    </>
  );
};

export default VideoPage;
